import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FDFDFD]">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#0052FF]"></div>
      </div>
    );
  }

  if (!user) {
    // Driver area uses its own login page
    if (allowedRoles.length === 1 && allowedRoles[0] === 'driver') {
      return <Navigate to="/livreur/login" state={{ from: location }} replace />;
    }
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  // If specific roles are required and user doesn't have them
  if (allowedRoles.length > 0 && !allowedRoles.includes(user.role)) {
    if (user.role === 'driver') return <Navigate to="/livreur" replace />;
    // Redirect customers to their account page
    if (user.role === 'customer') {
      return <Navigate to="/account" replace />;
    }
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;
